import createReducer from './utils/createReducer';
import * as c from '../constants/actions';

const initialState = {
  systemParameters: {},
  clubParameters: {},
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [c.GET_CLUB_PARAMETERS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.GET_CLUB_PARAMETERS_SUCCESS]: (state, { payload }) => ({
    ...state,
    clubParameters: payload,
    error: null,
    isLoading: false,
  }),
  [c.GET_CLUB_PARAMETERS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.SAVE_CLUB_PARAMETERS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.SAVE_CLUB_PARAMETERS_SUCCESS]: state => ({
    ...state,
    error: null,
    isLoading: false,
  }),
  [c.SAVE_CLUB_PARAMETERS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.GET_SYSTEM_PARAMETERS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.GET_SYSTEM_PARAMETERS_SUCCESS]: (state, { payload }) => ({
    ...state,
    systemParameters: payload,
    error: null,
    isLoading: false,
  }),
  [c.GET_SYSTEM_PARAMETERS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.SAVE_SYSTEM_PARAMETERS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.SAVE_SYSTEM_PARAMETERS_SUCCESS]: state => ({
    ...state,
    error: null,
    isLoading: false,
  }),
  [c.SAVE_SYSTEM_PARAMETERS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
});
